import { InjectionToken, inject } from '@angular/core';
import { Firestore, doc, getDoc } from '@angular/fire/firestore';
import { Observable, from } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserStatus } from '../models/user-status.model';

export type GetUserStatusFn = (uid: string) => Observable<UserStatus | null>;

/**
 * Injection token that provides a function to fetch a user's status from Firestore.
 * Using a token makes guards testable — tests override this with a mock function.
 */
export const GET_USER_STATUS = new InjectionToken<GetUserStatusFn>('GET_USER_STATUS', {
  providedIn: 'root',
  factory: () => {
    const firestore = inject(Firestore);
    return (uid: string) =>
      from(getDoc(doc(firestore, 'userStatus', uid))).pipe(
        map((snap) => (snap.exists() ? (snap.data() as UserStatus) : null)),
      );
  },
});
